import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useMemo } from "react"
import { usePlacementDetailsByOperationId } from "@/hooks/usePlacementDetailsByOperationId"
import { extractPlacementName } from "@/model/placement"

export const usePlacementName = (operationId?: string) => {
    const { token } = useAuth()
    const { data: placementDetails } = usePlacementDetailsByOperationId(
        token,
        operationId ? [operationId] : []
    )

    const placementName: string | undefined = useMemo(() => {
        if (!operationId) return undefined
        if (!placementDetails) return undefined

        const placementDetail = placementDetails[operationId]
        if (!placementDetail) return undefined

        return extractPlacementName(placementDetail)
    }, [operationId, placementDetails])

    return {
        placementName
    }
}
